import { Box, Tooltip, Typography } from "@mui/material";

const StatusCard = ({ icon, title, value, valueColor = "#2b3539", tooltip }) => {
  const card = (
    <Box display="flex" columnGap="15px" alignItems="center" flex={1}>
      {icon}
      <Box>
        <Typography color="#6a6a6a" fontSize="13px">
          {title}
        </Typography>
        <Typography color={valueColor} fontSize="14px">
          {value}
        </Typography>
      </Box>
    </Box>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} placement="top" arrow>
        {card}
      </Tooltip>
    );
  }

  return card;
};

export default StatusCard;
